:host {
  height: 100%;
  display: block;
}

.mobile-bar-shown ~ .flyer {
  --compliance-bottom-offset: calc(var(--mobile-bottom-bar-height) + var(--ui-space-xs));
}

.incentive-bar-shown ~ .flyer {
  --compliance-bottom-offset: calc(var(--incentive-bottom-bar-height, 97px) + var(--ui-space-xs));
}

ui-incentive-modal-container:not(.hidden) ~ .flyer {
  --compliance-bottom-offset: calc(var(--incentive-bottom-bar-height, 97px) + var(--ui-space-xs));
}
/* Paused on cashier routes (IGM-4164); beats ui-flyer-bar's `:host { display: contents }`. */
.flyer[hidden] {
  display: none;
}
